/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyResourceDetails {
    getFixupPrototypeFunction() { return CostAnomalyResourceDetails.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyResourceDetails>): CostAnomalyResourceDetails {
        let obj = Object.assign(new CostAnomalyResourceDetails(), model);
        CostAnomalyResourceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyResourceDetails>): CostAnomalyResourceDetails {
        if (!model) return null;
        return CostAnomalyResourceDetails.newInstance(<CostAnomalyResourceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyResourceDetails) {
        if (!obj) return;

        models.CostAnomalyResourceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyResourceDetails): boolean {
        Object.setPrototypeOf(obj, CostAnomalyResourceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_impact === undefined) {
            this.cost_impact = 0;
        }
        if (this.anomaly_count === undefined) {
            this.anomaly_count = 0;
        }
        if (this.upper_cost_bound === undefined) {
            this.upper_cost_bound = 0;
        }
        if (this.lower_cost_bound === undefined) {
            this.lower_cost_bound = 0;
        }
        if (this.expected_cost === undefined) {
            this.expected_cost = 0;
        }
        if (this.actual_cost === undefined) {
            this.actual_cost = 0;
        }
    }

    /**
     * Name of the resource
     */
    resource_id: string;

    /**
     * Cost incurred by the resource
     */
    cost_impact: number;

    /**
     * Anomaly Type of the cost. Example 'anomaly_type':'above_threshold'
     */
    anomaly_type: models.CostAnomalyType;

    /**
     * Product category wise anomaly count
     */
    anomaly_count: number;

    /**
     * Upper cost bound of daily cost anomaly summary
     */
    upper_cost_bound: number;

    /**
     * Lower cost bound of daily cost anomaly summary
     */
    lower_cost_bound: number;

    /**
     * Expected cost of daily cost anomaly summary
     */
    expected_cost: number;

    /**
     * Actual cost of daily cost anomaly
     */
    actual_cost: number;

}
